<template>
  <el-form
    class="process-form ghost-button-styles"
    ref="processFormRef"
    label-width="310px"
    :model="process"
    :rules="videoProcessFormRules()"
    @submit.native.prevent
  >
    <el-form-item label="原素材参与投放">
      <el-switch v-model="process.lauchFlag" />
    </el-form-item>
    <el-form-item label="添加贴纸">
      <el-switch v-model="process.pasted" />
    </el-form-item>
    <el-form-item v-if="process.pasted" prop="paster">
      <position ref="pasterPos" v-model="process.paster.position" :verify="verify" />
      <div class="m-wrap-body">
        <div class="m-paster-wrap">
          <paster-modal
            ref="pasterUrl"
            v-model="process.paster.url"
            :opacity="process.paster.opacity"
            :verify="verify"
            @on-select="selectPaster"
          />
        </div>
        <div class="paster-slider">
          <div class="text-slider">
            <div class="slider-title"><span>不透明度</span></div>
            <div class="slider">
              <el-slider v-model="process.paster.opacity" :min="0" :max="100" show-input input-size="small" />
            </div>
            <div class="slider-r"><span>%</span></div>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="添加水印">
      <el-switch v-model="process.wated" />
    </el-form-item>
    <el-form-item v-if="process.wated" prop="waterwark">
      <el-radio-group v-model="process.watertype">
        <el-radio-button ghost :label="1">贴纸</el-radio-button>
        <el-radio-button ghost :label="2">文字</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="process.wated && process.watertype === 1">
      <div class="m-wrap-body">
        <div class="m-paster-wrap">
          <paster-modal
            ref="waterUrl"
            v-model="process.waterwark.paster.url"
            :opacity="process.waterwark.paster.opacity"
            :verify="verify"
            @on-select="selectWaterPaster"
          />
        </div>
        <div class="paster-slider">
          <div class="text-slider">
            <div class="slider-title"><span>不透明度</span></div>
            <div class="slider">
              <el-slider v-model="process.waterwark.paster.opacity" :min="0" :max="100" show-input />
            </div>
            <div class="slider-r"><span>%</span></div>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item v-show="process.wated && process.watertype === 2">
      <el-input
        v-model="process.waterwark.word.text"
        style="width: 706px"
        placeholder="请输入添加的水印文字，不超过40个字符"
        maxlength="40"
        show-word-limit
      ></el-input>

      <div class="text-wrap">
        <div class="text-slider">
          <div class="slider-title"><span>不透明度</span></div>
          <div class="slider">
            <el-slider v-model="process.waterwark.word.opacity" :min="0" :max="100" show-input />
          </div>
          <div class="slider-r"><span>%</span></div>

          <div class="text-select">
            <span>字号</span>

            <el-select v-model="process.waterwark.word.fontsize" style="width: 62px; margin-left: 8px">
              <el-option v-for="font of fonts" :key="font" :value="font" :label="font"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="添加警示语">
      <el-switch v-model="process.warned" />
    </el-form-item>
    <el-form-item v-if="process.warned" prop="warnnings">
      <position ref="warnPos" v-model="process.warnnings.position" :verify="verify" />

      <el-input
        v-model="process.warnnings.text"
        rows="4"
        placeholder="请输入添加的警示语文字，不超过100个字符，回车换行"
        type="textarea"
        maxlength="100"
        show-word-limit
      ></el-input>

      <div class="text-wrap">
        <div class="text-slider">
          <div class="slider-title"><span>不透明度</span></div>
          <div class="slider" style="flex: 1">
            <el-slider v-model="process.warnnings.opacity" :min="0" :max="100" show-input />
          </div>
          <div class="slider-r"><span>%</span>&emsp;</div>

          <div class="text-select">
            <span>字号</span>
            <el-select v-model="process.warnnings.fontsize" style="width: 62px; margin-left: 8px">
              <el-option v-for="font in fonts" :key="font" :label="font" :value="font"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="衍生尺寸">
      <el-switch v-model="process.extend" />
      <span class="g-error-text" style="margin-left: 20px">注意：衍生尺寸只能横版衍生横版视频，竖版衍生竖版视频</span>
    </el-form-item>
    <el-form-item v-if="process.extend" prop="extendSize">
      <derives-size ref="extendSize" v-model="process.extendSize" :derives="derives" :max="14" :verify="verify" />
    </el-form-item>
    <el-form-item label="衍生素材名称">
      <p>跟母素材名称保持一致，加上衍生和编号</p>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, computed, reactive } from 'vue'
import { setLocal, getLocal } from '@/common/js/api'
import Cookies from 'js-cookie'
import PasterModal from '@/components/video/pastermodal'
import DerivesSize from '@/components/video/derives-size.vue'
import Position from '@/components/video/position.vue'
import { useVideoProcessFormRules } from '../hooks/useUpload.js'
import { derives, fonts } from '@/data/upload'

const account = Number(Cookies.get('ch_op_id'))

const processFormRef = ref(null)

const { lauchFlag, pasted, wated, warned, extend, paster, watertype, waterwark, warnnings, extendSize } =
  getOperatorStorage('custom-upldvideo')
const verify = ref(false)
const process = reactive({
  lauchFlag: lauchFlag || false,
  pasted: pasted || false,
  paster: paster || { position: '', opacity: 100, url: '' },
  wated: wated || false,
  watertype: watertype || 1,
  waterwark: Object.assign(
    {},
    {
      paster: { opacity: 60, url: '' },
      word: { text: '', opacity: 60, fontsize: 12 }
    },
    waterwark
  ),
  warned: warned || false,
  warnnings: warnnings || { position: '', text: '', opacity: 100, fontsize: 12 }, // 警示语
  extend: extend || false,
  extendSize: extendSize || [] // 衍生尺寸
})

const { videoProcessFormRules } = useVideoProcessFormRules(process)

const selectPaster = (id) => {
  process.paster.imageDetailId = id
}

const selectWaterPaster = (id) => {
  process.waterwark.paster.imageDetailId = id
}

function getOperatorStorage(name) {
  const storage = getLocal(name) || {}
  return storage[account] || {}
}

// eslint-disable-next-line
defineExpose({
  validate() {
    return processFormRef.value.validate()
  },
  getForm() {
    return process
  }
})
</script>

<style lang="scss" scoped>
.text-slider {
  display: flex;
  align-items: center;
  .slider {
    flex: 1;
  }
}
</style>
